import React, { ReactNode } from 'react'

import { MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'

import Iconify from '../../Iconify/Iconify'

// -------------------------------------------------------------------------------------------

type TableMoreMenuItemPropTypes = {
  onClick: () => void
  color?: string
  icon: string
  width?: number
  height?: number
  variant?: Variant
  children: ReactNode
  disabled?: boolean
}

const TableMoreMenuItem: React.FC<TableMoreMenuItemPropTypes> = ({
  onClick,
  color = 'text.secondary',
  icon,
  width = 24,
  height = 25,
  variant = 'body2',
  children,
  disabled,
}) => (
  <MenuItem onClick={onClick} sx={{ color }} disabled={disabled}>
    <ListItemIcon>
      <Iconify icon={icon} width={width} height={height} sx={{ color }} />
    </ListItemIcon>
    <ListItemText primary={children} primaryTypographyProps={{ variant }} />
  </MenuItem>
)

export default TableMoreMenuItem
